// ─── Category <-> Type Mapping ─────────────────────────────────────────────
export const LEGAL_TYPE_TO_CATEGORY = {
    ACTA_CONSTI:      'ACTA CONSTI',
    PODERES:          'PODERES',
    REGISTRO_PUBLICO: 'REGISTRO PUBLICO',
};

export const LEGAL_CATEGORY_TO_TYPE = {
    'ACTA CONSTI':      'ACTA_CONSTI',
    'PODERES':          'PODERES',
    'REGISTRO PUBLICO': 'REGISTRO_PUBLICO',
};

// ─── Schema per type ────────────────────────────────────────────────────────
// Field types: 'text', 'date', 'list', 'table'
// Table fields have `columns` defining each column's key, label, and type
export const LEGAL_SCHEMA = {
    ACTA_CONSTI: {
        label: 'Acta Constitutiva',
        sections: [
            {
                section: 'Datos Generales',
                fields: [
                    { path: 'razon_social',        label: 'Razón Social',        type: 'text' },
                    { path: 'fecha_constitucion',  label: 'Fecha Constitución',  type: 'date' },
                    { path: 'fecha_documento',     label: 'Fecha Documento',     type: 'date' },
                    { path: 'duracion_sociedad',   label: 'Duración Sociedad',   type: 'text' },
                    { path: 'domicilio_social',    label: 'Domicilio Social',    type: 'text' },
                    { path: 'notario_y_escritura', label: 'Notario y Escritura', type: 'text' },
                    { path: 'tipo_administracion', label: 'Tipo Administración', type: 'text' },
                ],
            },
            {
                section: 'Cuadro Accionario',
                fields: [
                    {
                        path: 'cuadro_accionario',
                        label: 'Cuadro Accionario',
                        type: 'table',
                        columns: [
                            { key: 'accionista',          label: 'Accionista',          type: 'text' },
                            { key: 'capital_o_porcentaje', label: 'Capital / Porcentaje', type: 'text' },
                        ],
                    },
                ],
            },
            {
                section: 'Personas con Poder de Firma',
                fields: [
                    {
                        path: 'personas_con_poder_firma',
                        label: 'Firmantes',
                        type: 'table',
                        columns: [
                            { key: 'nombre',     label: 'Nombre',     type: 'text' },
                            { key: 'facultades', label: 'Facultades', type: 'text' },
                        ],
                    },
                ],
            },
        ],
    },

    PODERES: {
        label: 'Poderes Notariales',
        sections: [
            {
                section: 'Datos del Poder',
                fields: [
                    { path: 'fecha_documento',     label: 'Fecha Documento',     type: 'date' },
                    { path: 'razon_social',        label: 'Razón Social',        type: 'text' },
                    { path: 'notario_y_escritura', label: 'Notario y Escritura', type: 'text' },
                ],
            },
            {
                section: 'Otorgantes',
                fields: [
                    { path: 'otorgantes', label: 'Otorgantes', type: 'list' },
                ],
            },
            {
                section: 'Apoderados',
                fields: [
                    {
                        path: 'apoderados',
                        label: 'Apoderados',
                        type: 'table',
                        columns: [
                            { key: 'nombre',                                label: 'Nombre',                  type: 'text' },
                            { key: 'facultades_dominio',                    label: 'Dominio',                 type: 'boolean' },
                            { key: 'facultades_administracion',             label: 'Administración',          type: 'boolean' },
                            { key: 'facultades_pleitos_cobranzas',          label: 'Pleitos y Cobranzas',     type: 'boolean' },
                            { key: 'facultades_titulos_credito_arrendamiento', label: 'Títulos / Arrendamiento', type: 'boolean' },
                            { key: 'limites_o_mancomunado',                 label: 'Límites / Mancomunado',   type: 'text' },
                        ],
                    },
                ],
            },
        ],
    },

    REGISTRO_PUBLICO: {
        label: 'Registro Público',
        sections: [
            {
                section: 'Datos de Inscripción',
                fields: [
                    { path: 'razon_social',               label: 'Razón Social',               type: 'text' },
                    { path: 'folio_mercantil_fme',        label: 'Folio Mercantil / FME',      type: 'text' },
                    { path: 'fecha_inscripcion_original', label: 'Fecha Inscripción Original',  type: 'date' },
                ],
            },
            {
                section: 'Reformas de Estatutos',
                fields: [
                    { path: 'reformas_estatutos', label: 'Reformas de Estatutos', type: 'list' },
                ],
            },
            {
                section: 'Administradores Inscritos',
                fields: [
                    {
                        path: 'administradores_inscritos_con_poder',
                        label: 'Administradores Inscritos con Poder',
                        type: 'list',
                    },
                ],
            },
            {
                section: 'Cuadro Accionario Inscrito',
                fields: [
                    {
                        path: 'cuadro_accionario_inscrito',
                        label: 'Cuadro Accionario Inscrito',
                        type: 'table',
                        columns: [
                            { key: 'accionista',          label: 'Accionista',          type: 'text' },
                            { key: 'capital_o_porcentaje', label: 'Capital / Porcentaje', type: 'text' },
                        ],
                    },
                ],
            },
        ],
    },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** Get all flat fields for a type */
export const getLegalFields = (type) => {
    const schema = LEGAL_SCHEMA[type];
    if (!schema) return [];
    const fields = [];
    schema.sections.forEach(s => s.fields.forEach(f => fields.push(f)));
    return fields;
};

/** Get flat field paths for a type */
export const getLegalFieldPaths = (type) => getLegalFields(type).map(f => f.path);

/** Category string for save calls */
export const categoryForType = (type) => LEGAL_TYPE_TO_CATEGORY[type] || type;

/** Canonical type for a category string */
export const typeForCategory = (cat) => LEGAL_CATEGORY_TO_TYPE[cat] || cat;

// ─── Legacy normalization ─────────────────────────────────────────────────────
export const normalizeExtracted = (extracted) => {
    if (!extracted) return {};
    const n = { ...extracted };
    if (!n.cuadro_accionario && n.cuadro_accionario_original)
        n.cuadro_accionario = n.cuadro_accionario_original;
    if (!n.apoderados && n.apoderado)
        n.apoderados = [{ nombre: n.apoderado, limites_o_mancomunado: n.limites_del_poder }];
    if (!n.fecha_documento && n.fecha_poder)
        n.fecha_documento = n.fecha_poder;
    if (!n.fecha_inscripcion_original && n.fecha_inscripcion)
        n.fecha_inscripcion_original = n.fecha_inscripcion;
    if (!n.administradores_inscritos_con_poder && n.ultimo_administrador_inscrito) {
        n.administradores_inscritos_con_poder = typeof n.ultimo_administrador_inscrito === 'string'
            ? [n.ultimo_administrador_inscrito]
            : n.ultimo_administrador_inscrito;
    }
    // reformas_estatutos: normalize string to array
    if (n.reformas_estatutos && typeof n.reformas_estatutos === 'string') {
        n.reformas_estatutos = [n.reformas_estatutos];
    }
    return n;
};

// ─── Serialization helpers ────────────────────────────────────────────────────

/** For API→editor: parse values from backend into editor format */
export const deserializeFieldValue = (field, value) => {
    if (field.type === 'table' || field.type === 'list') {
        if (typeof value === 'string') {
            try { return JSON.parse(value); } catch { return [value]; }
        }
        return Array.isArray(value) ? value : value ? [value] : [];
    }
    return value ?? '';
};

/** For editor→API: values are already in correct format from structured editors */
export const serializeFieldValue = (field, value) => value;
